import { ConfigProvider } from "melco-ui";
import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useSourceModifierDropdown } from "../../hooks/inputFormats/useSourceModifierDropdown";

type SelectSourceModifierProps = {
  name: string;
};

export const SelectSourceModifier: React.FC<SelectSourceModifierProps> = ({
  name,
}) => {
  const { t } = useTranslation();

  const { isLoading, isFetching, data, isPreviousData } =
    useSourceModifierDropdown();

  const sourceModifierOptions = (data ?? []).map((o) => ({
    value: o.id ?? "",
    label: o.name ?? "",
  }));

  return (
    <ConfigProvider renderEmpty={() => <>{t("global.fallback.none")}</>}>
      <SelectField
        name={name}
        label={t("dataMappings.form.label.sourceModifier")}
        loading={isPreviousData ? isFetching : isLoading}
        style={{ width: "100%" }}
        options={sourceModifierOptions}
        showSearch
        optionFilterProp="label"
        filterOption
        allowClear
        placeholder={t("global.fallback.none")}
        valueConverter={{
          toSelectValue: (value: number | undefined) =>
            value == 0 ? undefined : value, // the API uses 0 when no value has been set

          toFormValue: (value) => value,
        }}
      />
    </ConfigProvider>
  );
};
